import { IStoreState, ITripFilters } from '../../types'
import { getCurrentOrganization } from '../../state/reducers/organizations'
import { connect } from 'react-redux'
import TopBar from '../../components/navigation/TopBar'
import { RouteProps } from 'react-router'
import * as tripActions from '../../state/actions/trips'

//Do not remove this!
export function mapStateToProps(state: IStoreState, ownProps: any) {
  const currentService = Object.values(state.tripMenuService.items).filter(
    (service: any) => service.id === state.trips.filters.serviceId
  )[0]
  return {
    ...ownProps,
    currentOrganizationId: state.organizations.currentOrgId,
    tripTitle: currentService ? currentService.name : 'Requests',
    tripFilters: state.trips.filters
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    showMembers: () => dispatch(tripActions.actionCreators.showMembers()),
    updateTripFilters: (filters: ITripFilters) => dispatch(tripActions.actionCreators.updateTripFilters(filters))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TopBar)



// WEBPACK FOOTER //
// ./src/containers/navigation/TopBar.ts